export default "__VITE_ASSET__5RfWWgpX__"